import {
  GetTestResultsRequest,
  GetTestResultsResponse,
} from '@trustero/trustero-api-web/lib/evidence/testing_pb'
import { TestingPromiseClient } from '@trustero/trustero-api-web/lib/evidence/testing_grpc_web_pb'
import { SWRResponse } from 'swr'
import { TimeRange } from '@trustero/trustero-api-web/lib/common/time_pb'
import { useSwrImmutableGrpc } from '../useSwrImmutableGrpc'
import { useCurrentAudit } from '../model/audit'

/**
 * useLatestTestResults
 *
 *
 * @param request If the hook is invoked in a Continuous Compliance view, the
 *   request is passed as is.
 *   If it is invoked in an Audit view, the request will be updated to reflect
 *   the context of the current audit:
 *
 *   - If the model ids list has not been set, it will be updated with control
 *   ids in the audit
 *   - If the creation range is not set and the current audit has an interval,
 *   will set the interval of the audit to the request
 * @param shouldFetch if false, useSWR will not fire
 */

export const useTestResults = (
  request: GetTestResultsRequest,
  shouldFetch = true,
): SWRResponse<GetTestResultsResponse> => {
  const audit = useCurrentAudit()
  if (audit.data?.getIsInterval() && !request.hasCreationRange()) {
    request.setCreationRange(
      new TimeRange()
        .setSince(audit.data?.getStartDate())
        .setUntil(audit.data?.getEndDate()),
    )
  }
  const { response } = useSwrImmutableGrpc(
    TestingPromiseClient.prototype.getTestResults,
    request,
    shouldFetch,
  )
  return response
}
